export default "__VITE_ASSET__52582f69__"